import React from 'react';
import Story from "./Story";
import "./StoryReel.css";


function StoryReel() {
    return (
        <div className="storyReel">

            {/* Story */}
            <Story image="https://images.pexels.com/photos/1626557/pexels-photo-1626557.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" profileSrc="https://pbs.twimg.com/profile_images/896054298919960577/9QEd8NHq_400x400.jpg" title="ShadowX9" />

            {/* Story */}
            <Story image="https://images.pexels.com/photos/5014374/pexels-photo-5014374.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" profileSrc="https://images.pexels.com/photos/4617235/pexels-photo-4617235.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" title="ShadowX8" />

            {/* Story */}
            <Story image="https://images.pexels.com/photos/3363295/pexels-photo-3363295.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" profileSrc="https://pbs.twimg.com/profile_images/896054298919960577/9QEd8NHq_400x400.jpg" title="uAnon" />

            {/* Story */}
            <Story image="https://images.pexels.com/photos/2440799/pexels-photo-2440799.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" profileSrc="https://images.pexels.com/photos/4995558/pexels-photo-4995558.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500   " title="dotvhs" />

            {/* Story */}
            <Story image="https://images.pexels.com/photos/2710382/pexels-photo-2710382.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" profileSrc="https://images.pexels.com/photos/2553653/pexels-photo-2553653.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" title="denull" />

        </div>
    )
}

export default StoryReel
